import { get, post } from ".";

export const getTasksDataApi = async (projectId, taskId, includeCost) => {
  if (taskId) {
    return await get(`project/${projectId}/schedule/tasks?taskId=${taskId}`);
  } else if (includeCost) {
    return await get(`project/${projectId}/schedule/tasks?includeCost=${includeCost}`);
  } else {
    return await get(`project/${projectId}/schedule/tasks`);
  }
};

export const getScheduleHistoryApi = async (projectId) => {
  return await get(`project/${projectId}/schedule/schedule-history`);
};

export const uploadNewScheduleApi = async (projectId, params, includeCost) => {
  if (includeCost) {
    return await post(`project/${projectId}/schedule/new-schedule?includeCost=${includeCost}`, params);
  } else {
    return await post(`project/${projectId}/schedule/new-schedule`, params);
  }
};

export const exportScheduleApi = async (projectId, format, includeCost) => {
  if (includeCost) {
    return await get(`project/${projectId}/schedule/export-schedule?format=${format}&includeCost=${includeCost}`);
  } else {
    return await get(`project/${projectId}/schedule/export-schedule?format=${format}`);
  }
};

export const updateScheduleTasksApi = async (projectId, params) => {
  return await post(`project/${projectId}/schedule/update-tasks`, params);
};

export const exportScheduleTemplateApi = async (projectId, format) => {
  return await get(`project/${projectId}/schedule/schedule-template?format=${format}`);
};